module.exports = __webpack_public_path__ + "static/media/video_consent_audio_marathi.082d4c0f.mp3";